import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/thumbs";

const Product = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [activePackage, setActivePackage] = useState("op2"); // Default to option 2
  const [hiddenInputValue, setHiddenInputValue] = useState("2308"); // For the hidden input field

  const handlePackageClick = (selectedPackage, dataId) => {
    setActivePackage(selectedPackage);
    setHiddenInputValue(dataId);
  };
  const handleCheckout = () => {
    if (hiddenInputValue) {
      const redirectUrl = `https://order.diddys-oil.com/shipping.php?custom_product=${hiddenInputValue}`;
      window.location.href = redirectUrl; // Redirect to the checkout page
    } else {
      alert("Please select a product package first.");
    }
  };

  //const [showModal, setShowModal] = useState(false);

  // Function to open the modal
  //const openModal = () => setShowModal(true);

  // Function to close the modal
  //const closeModal = () => setShowModal(false);


  const slidesData = [
    { src: "images/slider1.jpg", alt: "Main Image 1", size : { width : 546, height : 533 }},
    { src: "images/slider2.jpg", alt: "Main Image 2", size : { width : 546, height : 533 } },
    { src: "images/slider3.jpg", alt: "Main Image 3", size : { width : 546, height : 533 } },
    { src: "images/slider4.jpg", alt: "Main Image 4", size : { width : 546, height : 533 } },
    { src: "images/slider5.jpg", alt: "Main Image 5", size : { width : 546, height : 533 } },
  ];

  return (
    <section className="product-gallery">
      <div className="container-xl">
        <div className="row">
          <div className="product_slider col-12 col-lg-6 px-0 px-md-2">
            {/* Main Slider */}
            <Swiper
              modules={[Thumbs]}
              thumbs={{ swiper: thumbsSwiper }}
              className="main-slider"
              loop={true}
              spaceBetween={10}
            >
              {slidesData.map((slide, index) => (
                <SwiperSlide key={`main-slide-${index}`}>
                  <img src={slide.src} alt={slide.alt} width={slide.size.width} height={slide.size.height} />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Thumbnail Slider */}
            <Swiper
              onSwiper={setThumbsSwiper}
              modules={[Thumbs]}
              slidesPerView={5}
              spaceBetween={10}
              className="thumb-slider"
              watchSlidesProgress
            >
              {slidesData.map((slide, index) => (
                <SwiperSlide key={`thumb-slide-${index}`}>
                  <img src={slide.src} width={slide.size.width} height={slide.size.height} alt={`Thumbnail ${index + 1}`} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div  className="product_info col-12 col-lg-6 pt-4 pt-lg-0 px-lg-4 px-md-2 px-0">
            <h1 className="heading">
              Party Like a Celebrity with{" "}
              <span className="primary">Diddy Baby Oil</span>
            </h1>
            <p className="subheading">
              The ultimate moisturizing oil that keeps your skin smooth, sexy,
              and ready for anything. Dry skin? Not tonight.
            </p>
            <div className="review">
              <svg
                width="141"
                height="21"
                viewBox="0 0 141 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5 0L12.8574 7.25532H20.4861L14.3143 11.7394L16.6717 18.9947L10.5 14.5106L4.32825 18.9947L6.68565 11.7394L0.513906 7.25532H8.1426L10.5 0Z"
                  fill="#FFCC00"
                />
                <path
                  d="M40.5 0L42.8574 7.25532H50.4861L44.3143 11.7394L46.6717 18.9947L40.5 14.5106L34.3283 18.9947L36.6857 11.7394L30.5139 7.25532H38.1426L40.5 0Z"
                  fill="#FFCC00"
                />
                <path
                  d="M70.5 0L72.8574 7.25532H80.4861L74.3143 11.7394L76.6717 18.9947L70.5 14.5106L64.3283 18.9947L66.6857 11.7394L60.5139 7.25532H68.1426L70.5 0Z"
                  fill="#FFCC00"
                />
                <path
                  d="M100.5 0L102.857 7.25532H110.486L104.314 11.7394L106.672 18.9947L100.5 14.5106L94.3283 18.9947L96.6857 11.7394L90.5139 7.25532H98.1426L100.5 0Z"
                  fill="#FFCC00"
                />
                <path
                  d="M130.5 0L132.857 7.25532H140.486L134.314 11.7394L136.672 18.9947L130.5 14.5106L124.328 18.9947L126.686 11.7394L120.514 7.25532H128.143L130.5 0Z"
                  fill="#FFCC00"
                />
              </svg>
              <span>4.9/5 based on ( 100 Review )</span>
            </div>
            <div className="product-price">$13.98</div>
            <ul className="product_info_list">
              <li>Deeply hydrates dry skin, leaving it silky and smooth.</li>
              <li>Perfect for sensitive areas (you know what we mean).</li>
              <li>Lightweight, non-greasy formula that absorbs fast.</li>
              <li>Adds a little excitement to your self-care routine.</li>
            </ul>
            <div className="bundle-div" id="prosec">
              <div className="bundle_heading">
                <span>Choose</span> your bundle
              </div>
              <div className="package-options">
                <label
                  className={`package ${
                    activePackage === "op1" ? "active" : ""
                  }`}
                  htmlFor="op1"
                  onClick={() => handlePackageClick("op1",2307)}
                >
                  <input
                    type="radio"
                    name="package"
                    id="op1"
                    data-id='2307'
                    checked={activePackage === "op1"}
                    readOnly
                  />
                  <div className="bundle-img">
                    <img
                      src="images/package1.png"
                      className="img-fluid"
                      alt="package 1"
                      width="134"
                      height="154"
                    />
                  </div>        
                  <div className="bundle-info">
                    <div className="bundle-name">1x Diddy Baby Oil</div>
                    <div className="bundle-price">
                      <span>$13.98</span> / ea
                    </div>
                  </div>
                </label>

                <label
                  className={`package ${
                    activePackage === "op2" ? "active" : ""
                  }`}
                  htmlFor="op2"
                  onClick={() => handlePackageClick("op2",2308)}
                >
                  <input
                    type="radio"
                    name="package"
                    id="op2"
                    data-id='2308'
                    checked={activePackage === "op2"}
                    readOnly
                  />
                  <div className="bundle-img">
                    <img
                      src="images/package2.png"
                      className="img-fluid"
                      alt="package 2"
                      width="134"
                      height="154"
                    />
                  </div>
                  <div className="bundle-info">
                    <div className="bundle-name">2x Diddy Baby Oil</div>
                    <div className="bundle-price">
                      <span>$13.98</span> / ea
                    </div>
                  </div>
                </label>

                <label
                  className={`package ${
                    activePackage === "op3" ? "active" : ""
                  }`}
                  htmlFor="op3"
                  onClick={() => handlePackageClick("op3",2309)}
                >
                  <input
                    type="radio"
                    name="package"
                    id="op3"
                    data-id='2308'
                    checked={activePackage === "op3"}
                    readOnly
                  />
                  <div className="bundle-img">
                    <img
                      src="images/package3.png"
                      className="img-fluid"
                      alt="package 3"
                      width="134"
                      height="154"
                    />
                  </div>
                  <div className="bundle-info">
                    <div className="bundle-name">3x Diddy Baby Oil</div>
                    <div className="bundle-price">
                      <span>$13.98</span> / ea
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <div className="seal-badge">
              <img
                src="images/seal-badge.png"
                className="img-fluid"
                alt="30 - DAY SATISFACTION GUARANTEE"
                width="97"
                height="95"
              />
              <div className="badge-text">
                <h4>30 - DAY SATISFACTION GUARANTEE</h4>
                <div>
                  If you are not satisfied with the product, simply return it
                  and we will refund your money.
                </div>
              </div>
            </div>
            <div className="button-wrapper">
            <div className="button-wrapper">
            <button className="button" onClick={handleCheckout}>
              Buy Now
            </button>
            <button className="button" onClick={handleCheckout}>
              Add to cart
            </button>
            </div>

            </div>
            <img
              src="images/all-cards.png"
              className="img-fluid" width="522" height="76"
              alt="All payment cards"
              loading="lazy"
              decoding="async"
            />
            <div className="secure">
              <img src="images/lock-alt.png" width="24" height="24" className="img-fluid" loading="lazy" decoding="async" alt="lock" />
              <span>Safe & Secure Payment</span>
            </div>
            <div className="shipping-mode-view">
              <div className="viewbox">
                <img
                  src="images/Free-Shipping.png"
                  width="72"
                  height="75"
                  loading="lazy" decoding="async"
                  className="img-fluid"
                  alt="Free Shipping"
                />
                <div>Free Shipping (3-5 day Delivery)</div>
              </div>
              <div className="viewbox">
                <img
                  src="images/Heart.png"
                  width="72"
                  height="75"
                  loading="lazy" decoding="async"
                  className="img-fluid"
                  alt="Happy Customer"
                />
                <div>200k+ Happy Customers</div>
              </div>
              <div className="viewbox">
                <img
                  src="images/Return.png"
                  width="72"
                  height="75"
                  loading="lazy" decoding="async"
                  className="img-fluid"
                  alt="Return"
                />
                <div>Hassle Free Returns</div>
              </div>
            </div>
            <input
                type="hidden"
                name="selectedPackageId"
                value={hiddenInputValue}
              />
          </div>
        </div>
      </div>
   
     

      {/* {showModal && (
        <div
          className="modal fade show d-block"
          role="dialog"
          id="modalPro"
          tabIndex="-1"
          aria-labelledby="modalprolabel"
          aria-hidden="false"

        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                  aria-label="Close"
                >
                  x
                </button>

                <h3>Quick Message from our Owner and CEO James Kasey!</h3>

                <video
                  id="videoPlayer"
                  controls
                  poster="images/landscape-video-thumb.jpg"
                  playsInline
                >
                  <source
                    id="videoSource"
                    src="images/video-landscape.mp4"
                    type="video/mp4"
                  />
                </video>

                <button
                  className="btn btn-dark btn-md go-next mx-auto d-block"
                  onClick={closeModal}
                  aria-label="Close"
                >
                  Continue To Checkout
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </section>
  );
};

export default Product;
